import React, { useContext, useEffect, useState } from 'react'
import { Input, TreeSelect, Spin, App } from "antd";
import { API, Enum } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios";

// Interfaces
import { AxiosError } from "../../../interfaces/axios"
import type { DataNode } from 'antd/es/tree';

enum CUEnum {
    Add = "ADD",
    Edit = "Edit"
}

const { Pages: { FileManagement: { Directory: DirectoryLanguage } }, Share, Validation, Message: MessageLanguage } = language
const { FILE_MANAGEMENT_DIRECTORY_ID, FILE_MANAGEMENT_DIRECTORY_CREATE, FILE_MANAGEMENT_DIRECTORY_UPDATE } = API
const { Message } = Enum

export default function CUDirectory(props: { Form: any, form: any, getCategories: () => void, Categories: DataNode[], Directory: DataNode|null, type: CUEnum }) {
    const { Form, form, getCategories, Categories, Directory, type } = props;

    const { axios } = useContext(AxiosContext)
    const [loadingRecord, setLoadingRecord] = useState<boolean>(false)
    const { message } = App.useApp()

    useEffect(() => {
        form.resetFields()
        if (Directory)
            if (type === CUEnum.Edit) {
            setLoadingRecord(true)
            axios.get(FILE_MANAGEMENT_DIRECTORY_ID + Directory.key).then((response: { data: { parent: { id: number } } }) => {
                const { data: directory } = response
                form.setFieldsValue({ ...directory, parent: directory?.parent?.id })
                setLoadingRecord(false)
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response )
                form.resetFields()
                setLoadingRecord(false)
            })
        } else form.setFieldsValue({ parent: Directory.key })
    }, []);

    const onFinish = ((directory: {}) => {
        setLoadingRecord(true)
        if (Directory && (type === CUEnum.Edit)) {
            axios.patch(FILE_MANAGEMENT_DIRECTORY_UPDATE + Directory.key, directory).then((response: {}) => {
                message.success(MessageLanguage[Message.UPDATE_RECORD]).then(response => response)
                setLoadingRecord(false)
                getCategories()
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        } else {
            axios.post(FILE_MANAGEMENT_DIRECTORY_CREATE, directory).then((response: {}) => {
                message.success(MessageLanguage[Message.CREATE_RECORD]).then(response => response)
                form.resetFields()
                setLoadingRecord(false)
                getCategories()
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        }
    })

    return (
        <Spin spinning={loadingRecord} tip={Share.loading} size="large">
            <Form form={form} name="cu-directory" onFinish={onFinish} style={{ margin: '25px 0 10px 0'}}>
                <Form.Item
                    label={DirectoryLanguage.title}
                    name="title"
                    hasFeedback
                    rules={[
                        { required: true, message: `${DirectoryLanguage.title} ${Validation.required}` },
                    ]}
                >
                    <Input minLength={3} />
                </Form.Item>
                <Form.Item
                    label={DirectoryLanguage.parent}
                    name="parent"
                >
                    <TreeSelect
                        showSearch
                        allowClear
                        treeDefaultExpandAll
                        treeNodeFilterProp="title"
                        placeholder={DirectoryLanguage.parent}
                        treeData={Categories}
                    />
                </Form.Item>
            </Form>
        </Spin>
    )
}
